<template>
  <div class="cta-area ptb-100">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
          <div class="cta-content" data-aos="fade-right" data-aos-duration="1200">
            <span class="sub-title">
              <i class="flaticon-whatsapp"></i>
              Fale com a gente
            </span>
            <h2>Transforme sua ideia em realidade</h2>
            <p>Entre em contato agora mesmo pelo WhatsApp e converse com nossos especialistas. Resposta rápida, atendimento personalizado e soluções sob medida para o seu negócio.</p>

            <div class="benefits-list">
              <div class="benefit-item">
                <i class="ph-check-circle"></i>
                <span>Resposta em até 1 hora</span>
              </div>
              <div class="benefit-item">
                <i class="ph-check-circle"></i>
                <span>Orçamento sem compromisso</span>
              </div>
              <div class="benefit-item">
                <i class="ph-check-circle"></i>
                <span>Consultoria gratuita</span>
              </div>
            </div>

            <div class="cta-buttons">
              <a href="https://wa.me/5554992302401?text=Olá! Quero desenvolver um projeto com a Fontes Business"
                 target="_blank"
                 class="btn-style-one green-color btn-lg"
                 rel="noopener noreferrer">
                Chamar no WhatsApp
              </a>
              <a href="tel:+5554992302401" class="btn-style-one outline-color btn-lg">
                (54) 99230-2401
              </a>
            </div>

            <div class="contact-info">
              <div class="info-item">
                <i class="ph-envelope-simple"></i>
                <a href="mailto:contato@fontes.business">contato@fontes.business</a>
              </div>
              <div class="info-item">
                <i class="ph-clock"></i>
                <span>24h/7</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-12">
          <div class="cta-image" data-aos="fade-left" data-aos-duration="1200">
            <div class="image-wrapper">
              <img src="../../assets/images/subscribe1.png" alt="Contato Fontes Business">
              <div class="floating-whatsapp">
                <i class="flaticon-whatsapp"></i>
                <div class="pulse-ring"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Background Elements -->
    <div class="shape-bg">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subscribe'
}
</script>

<style scoped>
.cta-area {
  position: relative;
  background: linear-gradient(135deg, #6D5DFC 0%, #4361EE 100%);
  overflow: hidden;
}

.cta-area::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg width="100" height="100" xmlns="http://www.w3.org/2000/svg"><defs><pattern id="grid" width="100" height="100" patternUnits="userSpaceOnUse"><path d="M 100 0 L 0 0 0 100" fill="none" stroke="rgba(255,255,255,0.05)" stroke-width="1"/></pattern></defs><rect width="100%" height="100%" fill="url(%23grid)"/></svg>');
  opacity: 0.5;
}

.cta-content {
  position: relative;
  z-index: 2;
  color: white;
}

.sub-title {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.2);
  padding: 8px 20px;
  border-radius: 50px;
  font-weight: 600;
  margin-bottom: 20px;
  backdrop-filter: blur(10px);
}

.sub-title i {
  font-size: 20px;
}

.cta-content h2 {
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.2;
  color: white;
}

.cta-content p {
  font-size: 18px;
  line-height: 1.8;
  margin-bottom: 30px;
  opacity: 0.95;
  color: white;
}

.benefits-list {
  display: grid;
  gap: 15px;
  margin-bottom: 30px;
}

.benefit-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-weight: 500;
}

.benefit-item i {
  font-size: 24px;
  color: #25D366;
}

.cta-buttons {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.btn-lg {
  padding: 15px 30px;
  font-size: 16px;
  font-weight: 600;
}

.btn-style-one.green-color {
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  border: none;
  box-shadow: 0 6px 20px rgba(37, 211, 102, 0.4);
}

.btn-style-one.green-color:hover {
  background: linear-gradient(135deg, #128C7E 0%, #075E54 100%);
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(37, 211, 102, 0.5);
}

.btn-style-one.outline-color {
  background: transparent;
  border: 2px solid white;
  color: white;
}

.btn-style-one.outline-color:hover {
  background: white;
  color: #6D5DFC;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.info-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
}

.info-item i {
  font-size: 20px;
}

.info-item a {
  color: white;
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.info-item a:hover {
  opacity: 0.8;
}

.cta-image {
  position: relative;
  z-index: 2;
}

.image-wrapper {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
}

.floating-whatsapp {
  position: absolute;
  bottom: 30px;
  right: 30px;
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 40px rgba(37, 211, 102, 0.5);
  animation: pulse 2s infinite;
}

.floating-whatsapp i {
  font-size: 40px;
  color: white;
}

.pulse-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid #25D366;
  border-radius: 50%;
  animation: pulse-ring 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes pulse-ring {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

.shape-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1;
}

.shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
  animation: float 20s infinite;
}

.shape-1 {
  width: 400px;
  height: 400px;
  top: -200px;
  right: -100px;
  animation-delay: 0s;
}

.shape-2 {
  width: 300px;
  height: 300px;
  bottom: -150px;
  left: -50px;
  animation-delay: 5s;
}

.shape-3 {
  width: 200px;
  height: 200px;
  top: 50%;
  left: 50%;
  animation-delay: 10s;
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0) rotate(0deg);
  }
  33% {
    transform: translate(30px, -30px) rotate(120deg);
  }
  66% {
    transform: translate(-20px, 20px) rotate(240deg);
  }
}

@media (max-width: 991px) {
  .cta-content h2 {
    font-size: 32px;
  }

  .cta-buttons {
    flex-direction: column;
  }

  .btn-lg {
    width: 100%;
    justify-content: center;
  }

  .cta-image {
    margin-top: 40px;
  }
}
</style>